export default __webpack_public_path__ + "static/media/start.e403ad32.svg";